module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meetingroom"
  }, [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent is-12"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/meetingroom/waomeeting-01-4.jpg",
      "alt": "meeting room bratislava cowork"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-vertical is-6"
  }, [_c('div', {
    staticClass: "tile"
  }, [_c('div', {
    staticClass: "tile is-parent is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/cowork/women_coworkers.jpg",
      "alt": "private office room bratislava cowork"
    }
  })])]), _vm._v(" "), _c('article', {
    staticClass: "tile is-child"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/cowork/focus_room_coworking_bratislava.jpg",
      "alt": "street view bratislava cowork"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-size-4"
  }, [_c('article', {
    staticClass: "tile is-child notification is-black"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("💼 Private Office Dunajska")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("🌃 24/7 access")]), _vm._v(" "), _c('p', [_vm._v("🔑 Dedicated office with all basic equipment (tables, chairs)")]), _vm._v(" "), _c('p', [_vm._v("⚡️ Ultra-fast Internet")]), _vm._v(" "), _c('p', [_vm._v("🔇 Accoustically insulated")]), _vm._v(" "), _c('p', [_vm._v("🚴‍♀️ Bicycle parking U-rack")]), _vm._v(" "), _c('p', [_vm._v("🤝 Meeting Rooms")]), _vm._v(" "), _c('p', [_vm._v("📍 Downtown location, Dunajska 14, Bratislava")]), _vm._v(" "), _c('p', [_vm._v("🥗 Lot of food options around")]), _vm._v(" "), _c('p', [_vm._v("🚗 Parking available (paid extra)")]), _vm._v(" "), _c('p', [_vm._v("📬 Company address and postal service (paid extra)")]), _vm._v(" "), _c('p', [_vm._v("💞 By renting our private office you are supporting community")]), _vm._v(" "), _c('p', [_vm._v("🕰 Available on Q1 2020")])]), _vm._v(" "), _c('div', {
    staticClass: "btn-container"
  }, [_c('a', {
    staticClass: "button is-black is-block is-large meeting",
    attrs: {
      "href": "https://docs.google.com/forms/d/e/1FAIpQLSd1WbCPxlLyeKyDHNMLFCHCyjOnz946WjCIlDPAq4XIE_8eKQ/viewform"
    }
  }, [_vm._v("\n              Submit your interest")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/meetingroom/pb-02.jpg",
      "alt": "meeting room bratislava cowork"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7923776e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrivateOffice.vue
// module id = 255
// module chunks = 9